/// <amd-module name="Environments/CreatePanel/Stores/EnvironmentsCreatePanelStore" />
import { ActionsHubManager } from "Environments/Flux/ActionsHubManager";
import { EnvironmentsCreatePanelActions } from "Environments/CreatePanel/Actions/EnvironmentsCreatePanelActions";
import { EnvironmentInstance } from "DistributedTask/Client/Contracts/TaskAgent";
import { StoreBase, IStoreState } from "Environments/Flux/Store"

import { Operation } from "Environments/CreatePanel/Common/Utils";

export interface IEnvironmentStoreState extends IStoreState {
    environment: EnvironmentInstance;
}

export class EnvironmentsCreatePanelStore extends StoreBase {

    public static getKey(): string {
        return "environments-create-panel-store";
    }
    
    public initialize(instanceId: string): void {
        super.initialize(instanceId);
        
        this._actionsHub = ActionsHubManager.GetActionsHub<EnvironmentsCreatePanelActions>(EnvironmentsCreatePanelActions, instanceId);
        this._actionsHub.createEnvironment.addListener(this._handleCreateEnvironment);
    }
    
    protected disposeInternal(): void {
        this._actionsHub.createEnvironment.removeListener(this._handleCreateEnvironment);
    }

    public getState(): IEnvironmentStoreState {
        return this._state;
    }

    public getEnvironment(): EnvironmentInstance {
        return this._state.environment;
    }

    private _handleCreateEnvironment = (environment: EnvironmentInstance) => {
        this._state.environment = environment;
        this.emit(Operation.Create, this);
    }

    private _actionsHub: EnvironmentsCreatePanelActions;
    private _state: IEnvironmentStoreState = {} as IEnvironmentStoreState;
}
